export default {
  LOBBY: 0,
  GAME_OVER: 1,
  GAME_WAIT_TO_START: 2,
  GAME_YOUR_TURN: 3,
  GAME_WAIT_TURN: 4,
  GAME_LOBBY: 5,
  GAME_CREATE: 6,
  HOME: 7,
};